import React from "react";

import { moneyFormat } from "./format";
import MoneyTable, { populateKeys } from "./MoneyTable";
import TwoPanels from "./TwoPanels";
import Text from "./Text";

const cashFlowKeys = [
  {
    group: "Operating Activities",
    rows: [
      { key: "Cash received from Customers", label: "Customers" },
      { key: "Cash payment for Wages", label: "Wages" },
      { key: "Cash payments for Purchases", label: "Suppliers" },
      {
        key: "Cash payments for Operating expenses",
        label: "Other Operating Expenses"
      },
      { key: "Cash payment for Interests", label: "Interests" },
      { key: "Cash payment for Income Taxes", label: "Income Taxes" },
      {
        key: "Total Cash Flows from Operations",
        label: "Cash Flows from Operations"
      }
    ]
  },
  {
    group: "Investing Activities",
    rows: [
      { key: "Capital Expenditure Purchases", label: "Capex Purchases" },
      { key: "Capital Expenditure Sales", label: "Capex Sales" },
      {
        key: "Total Cash Flows from Investing",
        label: "Cash Flows from Investing"
      }
    ]
  },
  {
    group: "Financing Activities",
    rows: [
      {
        fn: data => data["Debt Borrowed"] + data["Stock Issuance"],
        label: "Raised Capital"
      },
      {
        fn: data => data["Debt Repaid"] + data["Stock Repurchase"],
        label: "Returned Capital"
      },
      { key: "Dividends", label: "Dividends" },
      {
        key: "Total Cash Flows from Financing",
        label: "Cash Flows from Financing"
      }
    ]
  },
  {
    group: "",
    rows: [
      { key: "Net Change in Cash", label: "Net Cash Received" },
      { key: "Beginning Cash", label: "Beginning Cash" },
      { key: "Ending Cash", label: "Ending Cash" }
    ]
  }
];

const CashFlows = ({ round, cashFlows }) => {
  const totalFinancing = cashFlows["Total Cash Flows from Financing"];
  const totalInvesting = cashFlows["Total Cash Flows from Investing"];
  const totalOperations = cashFlows["Total Cash Flows from Operations"];

  return (
    <TwoPanels title1="Cash Flows" title2="Cash Flows">
      <fragment>
        <Text>This section breaks down your cash activities.</Text>
        <Text>
          In this game, you start out by raising capital (i.e. Financing
          Activities). You then used that capital to invest in long lived assets
          such as your production line lines (i.e. Investing activities). These
          long-lived assets were then used in your operations, which includes
          creating, marketing, producing, and selling products to generate
          revenues and profits (i.e. Operating activities).
        </Text>
        <Text>
          In Year {round}, your team net{" "}
          {totalFinancing > 0 ? "raised" : "returned"}{" "}
          {moneyFormat(Math.abs(totalFinancing))}{" "}
          {totalFinancing > 0 ? "from" : "to"} investors in financing
          activities. You also net {totalInvesting < 0 ? "used" : "received"}{" "}
          {moneyFormat(Math.abs(totalInvesting))}{" "}
          {totalInvesting < 0 ? "to acquire" : "from sale of"} long lived
          assets. Lastly, your operation activities resulted in net cash{" "}
          {totalOperations < 0 ? "used" : "received"} of{" "}
          {moneyFormat(Math.abs(totalOperations))}
        </Text>
      </fragment>
      <MoneyTable keys={populateKeys(cashFlowKeys, cashFlows)} />
    </TwoPanels>
  );
};

export default CashFlows;



// WEBPACK FOOTER //
// ./src/components/analysis/CashFlows.js